import UILabel from "components/ui/UILabel";
import styled, { css } from "styled-components";

const BaseDollarSign = (props) => <UILabel.XLarge {...props}>$</UILabel.XLarge>;

const DollarSign = styled(BaseDollarSign)``;

const Wrapper = styled.div<{ $isEwa?: boolean }>`
  overflow: hidden;

  border-radius: 12px;
  box-shadow: 0 0 0 1.5px
    ${(props) =>
      props.$isEwa ? props.theme.colors.primary : props.theme.colors.disabled};

  transition: all 150ms;
`;

const Header = styled.div<{ $isEwa?: boolean }>`
  display: flex;
  gap: 4px;
  padding: 0 8px;

  background: ${(props) =>
    props.$isEwa ? props.theme.colors.primary : props.theme.colors.disabled};
  color: ${(props) =>
    props.$isEwa
      ? `${props.theme.reverseColors.primary}CC`
      : props.theme.reverseColors.disabled};

  transition: all 150ms;
`;

const BaseDay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
`;

const Month = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
`;

const Week = styled.div`
  display: flex;
  gap: 4px;
`;

const Day = styled(BaseDay)<{
  $isVisible?: boolean;
  $isPayday?: boolean;
  $delay?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;

  border-radius: 3px;

  transition: all 150ms ${(props) => props.$delay}ms;

  ${(props) =>
    props.$isVisible
      ? ""
      : css`
          opacity: 0;
        `}

  ${DollarSign} {
    transition: all 150ms ${(props) => props.$delay}ms;
  }

  ${(props) =>
    props.$isPayday
      ? css`
          background: ${props.theme.colors.success};
          box-shadow: 0 0 0 1.5px ${(props) => props.theme.colors.primary}44
            inset;

          ${DollarSign} {
            transform: translateY(0);

            opacity: 1;
          }
        `
      : css`
          background: ${(props) => props.theme.colors.secondary}22;
          box-shadow: 0 0 0 1.5px ${(props) => props.theme.colors.primary}44
            inset;

          ${DollarSign} {
            transform: translateY(-4px);

            opacity: 0;
          }
        `}
`;

const Calendar = ({ isEwa }) => {
  return (
    <Wrapper $isEwa={isEwa}>
      <Header $isEwa={isEwa}>
        {["S", "M", "T", "W", "T", "F", "S"].map((day, dayIndex) => (
          <BaseDay key={dayIndex}>
            <UILabel.Small>{day}</UILabel.Small>
          </BaseDay>
        ))}
      </Header>

      <Month>
        {new Array(5).fill(0).map((_, weekIndex) => (
          <Week key={weekIndex}>
            {new Array(7).fill(0).map((_, dayIndex) => {
              const isVisible =
                !(weekIndex === 0 && [0, 1].includes(dayIndex)) &&
                !(weekIndex === 4 && [3, 4, 5, 6].includes(dayIndex));
              const isPayday = isEwa || (weekIndex % 2 && dayIndex === 5);

              return (
                <Day
                  $isVisible={isVisible}
                  $isPayday={isPayday}
                  $delay={(weekIndex + dayIndex) * 50}
                  key={`${weekIndex}-${dayIndex}`}
                >
                  <DollarSign />
                </Day>
              );
            })}
          </Week>
        ))}
      </Month>
    </Wrapper>
  );
};

export default Calendar;
